import IndexPage from "pages";
import DevelopPage from "pages/decks";
import RosterPage from "pages/roster";
import PublicRosterPage from "pages/roster/[id]";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "firebase/auth";
import { FirebaseAppProvider } from "reactfire";
import Container from "components/Container";

import "react-notifications/lib/notifications.css";
import TrainerPage from "components/TrainerPage";

const firebaseConfig = {
  apiKey: "AIzaSyDMwDpA8v9Bg8GfVipTPFxasHuNR9niGoA",
  authDomain: "ss2020-7b268.firebaseapp.com",
  projectId: "ss2020-7b268",
  storageBucket: "ss2020-7b268.appspot.com",
  messagingSenderId: "465350295317",
  appId: "1:465350295317:web:1fb6947267cce445a3f31c",
  measurementId: "G-LD68Q8MKLW",
};

export default function BasicExample() {
  return (
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <Container>
        <Router>
          <Switch>
            <Route exact path="/">
              <IndexPage />
            </Route>

            <Route path="/roster" exact>
              <RosterPage />
            </Route>

            <Route path="/roster/:id" children={<PublicRosterPage />} />

            <Route path="/decks">
              <DevelopPage />
            </Route>

            <Route path="/trainer">
              <TrainerPage />
            </Route>
          </Switch>
        </Router>
      </Container>
    </FirebaseAppProvider>
  );
}
